import Dashboard from "@material-ui/icons/Dashboard";
import Assignment from "@material-ui/icons/Assignment";
import AccountBalanceWallet from "@material-ui/icons/AccountBalanceWallet";

const SidebarLinks = [
  {
    name: "Applications",
    icon: Dashboard,
    role: [],
    designation: [],
    children: [
      {
        name: "In Process",
        url: "/Dashboard",
        status: "APPLICATIONS",
        icon: Assignment,
        role: [],
        designation: [],
      },
      {
        name: "Active Loans",
        url: "/Repayment",
        status: "ACTIVE_LOANS",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "In Process",
        url: "/AdminPortal",
        status: "INPROCESS",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Approved",
        url: "/AdminPortal",
        status: "APPROVED",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Submitted",
        url: "/AdminPortal",
        status: "SUBMITTED",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Repayment Schedule",
        url: "/AdminPortal",
        status: "LEAD_REPAYMENT_SCHEDULE",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Sanction Esign",
        url: "/AdminPortal",
        status: "LEAD_SANCTION_ESIGN",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Completed",
        url: "/AdminPortal",
        status: "COMPLETED",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
      {
        name: "Rejected",
        url: "/AdminPortal",
        status: "REJECTED",
        icon: AccountBalanceWallet,
        role: [],
        designation: [],
      },
    ],
  },
  {
    name: "Reject Application",
    url: "/rejectApplication",
    icon: AccountBalanceWallet,
    code: "REJECT_APPLICATION",
  },
  {
    name: "Lead Assignement",
    url: "/leadAssign",
    icon: AccountBalanceWallet,
    code: "LEAD_ASSIGNED",
  },
];

export default SidebarLinks;